
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";

interface EditButtonProps {
  onClick: () => void;
}

export function EditButton({ onClick }: EditButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="hover:bg-[#0073B7] hover:text-white"
      title="Editar orçamento"
    >
      <Edit className="h-4 w-4" />
    </Button>
  );
}
